import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineHomeIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m21.66 10.25-9-8a1 1 0 0 0-1.32 0l-9 8a.9999.9999 0 0 0-.27 1.11A1.0002 1.0002 0 0 0 3 12h1v9a1 1 0 0 0 1 1h14a1.0001 1.0001 0 0 0 1-1v-9h1a.9998.9998 0 0 0 .93-.64 1.0001 1.0001 0 0 0-.27-1.11ZM13 20h-2v-3a1.0001 1.0001 0 0 1 2 0v3Zm5 0h-3v-3a3 3 0 0 0-6 0v3H6v-8h12v8ZM5.63 10 12 4.34 18.37 10H5.63Z"/>
  </SvgIcon>
}

export default LineHomeIcon
